import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { UserChangeHistoriesRoute } from '../../routing'

export class UserChangeHistoriesPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <UserChangeHistoriesRoute />
            </Fragment>
        )
    }
}
